import VendorIndex from "@/views/vendor/VendorIndex.vue";

const vendor = [
    {
        path: '/vendor',
        name: 'vendor',
        component: VendorIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office', 'Manager Driver'], 
        },
    }
]

export default vendor;